import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import {useEffect, useState} from "react";

export default function CircularIndeterminate(props) {
    const [canShow, setCanShow] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setCanShow(true)
        }, 2000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            {canShow ? (
                <>
                    {props.componentShow}
                </>
            ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    {!props.notShowLoading && (<CircularProgress />)}
                </Box>
            )}
        </>
    );
}